import Density from "../../../../components/Operation/Density2";
import { datetime } from "../../../../util/library/datetime";
import { DELIVERY_TYPE, deliveryType, KeyOfStep, SHORT_DATETIME_FORMAT } from "../../../../util/varibles/constants";
import { convertStepName, firstLetter, stepNameV2 } from "../../../../util/varibles/global";
import { IActivityLog, IHarvest, IHarvest2, IOperation2, IStorage, ISubStepActivityLog, TOperation } from "../../../../util/varibles/interface";
import InfoFish from "../../../PlanOperationPage/Popup/EditOp/_components/InfoFish";
import styles from "./style.module.scss";

interface IStepProps {
    data: IActivityLog
    sub_operations: TOperation['sub_operations']
    deliveryTypes?: Record<string, string>
    vesselTanks: IHarvest['tanks']
}

const NormalStep: React.FC<IStepProps> = ({ data }) => {
    const { est_start_time } = data;
    return <div className={styles.step}>
        <div className="leading-[16px]">{est_start_time ? datetime(est_start_time).format(SHORT_DATETIME_FORMAT) : ""}</div>
        <div className='text-[18px]'>{convertStepName([data.key])}</div>
    </div>;
};

const Harvesting: React.FC<IStepProps> = ({ data, sub_operations, vesselTanks }) => {
    const { sub_steps = [], key, real_start_time } = data;
    const tanks = (vesselTanks as IHarvest['tanks']).reduce((rs: { [id: string]: IHarvest['tanks'][0] }, item) => {
        rs[item.id] = item
        return rs
    }, {})
    const units = sub_operations.reduce((rs: { [id: string]: typeof sub_operations[number] }, item) => {
        rs[item.id] = item
        return rs
    }, {})

    const groupByUnit = sub_steps.reduce((rs: {
        [id: string]: { [id: string]: ISubStepActivityLog }
    }, item) => {
        const { sub_id = '', tank_id } = item;
        rs[sub_id] = {
            ...rs[sub_id] || {},
            [tank_id]: item
        }
        return rs;
    }, {})

    return <div className={styles.step}>
        {sub_steps.length > 0
            ? Object.keys(groupByUnit).map(key => {
                const unit = groupByUnit[key] || {};
                const { unit_id } = units[key] || {};
                return <div key={key} className='flex gap-4 w-full'>
                    {vesselTanks.map(item => {
                        const {
                            sub_id,
                            est_start_time = 0,
                            est_finish_time,
                        } = unit[item.id || ''] || {};
                        if (!est_start_time)
                            return <div key={item.id} className={styles.tankStep} />

                        return <div key={item.id} className={styles.tankStep}>
                            <div className='font-[600] mb-1'>{unit_id || sub_id}</div>
                            <div className='flex flex-col'>
                                <div data-lev='est-time'>{datetime(est_start_time).format(SHORT_DATETIME_FORMAT)}</div>
                            </div>
                            <div className='flex flex-col items-end' data-lev='job'>
                                <div className='text-[18px] leading-[20px]'>Loading</div>
                                <div className='flex'>(<InfoFish data={unit[item.id || ''] || {}} />)</div>
                                <div className={[styles.arrow, 'arrow-down'].join(' ')}></div>
                            </div>
                            <div className='flex flex-col'>
                                <div data-lev='est-time'>{datetime(est_finish_time).format(SHORT_DATETIME_FORMAT)}</div>
                            </div>
                        </div>
                    })}
                </div>
            })
            : <div className='flex flex-col items-center'>
                <div data-lev='est-time'>{real_start_time ? datetime(real_start_time).format(SHORT_DATETIME_FORMAT) : '...'}</div>
                <div className='text-[18px]'>{stepNameV2(key)}</div>
            </div>}
        <div className='flex gap-4 w-full mt-2'>
            {vesselTanks.map(item => {
                const { density = 0, max_density = 0 } = tanks[item.id || ''] || {};
                return <div className='tank-op' key={item.id}>
                    <div className='bg-[var(--bgSidebar1)] px-[10px] flex items-center'>
                        <InfoFish data={tanks[item.id || ''] || {}} />
                    </div>
                    <div className='flex justify-between gap-2 px-[10px]'>
                        <div>{item.name}</div>
                        <Density density={density} max_density={max_density} />
                    </div>
                </div>
            })}
        </div>
    </div>;
};

const Discharging: React.FC<IStepProps> = ({ data, deliveryTypes = {}, vesselTanks }) => {
    const { sub_steps = [], key, real_start_time } = data;
    const groupByTank = sub_steps.reduce((rs: {
        [id: string]: ISubStepActivityLog[]
    }, item) => {
        const { tank_id } = item;
        rs[tank_id] = [...rs[tank_id] || [], item]
        return rs;
    }, {})

    return <div className={styles.step}>
        <div className='flex gap-4 w-full justify-center'>
            {sub_steps.length > 0
                ? vesselTanks.map(item => {
                    const data = groupByTank[item.id || ''] || [];
                    return <div className='flex flex-col gap-2 w-full' key={item.id}>
                        {data.map(sub => {
                            const {
                                est_start_time,
                                est_finish_time,
                                delivery_type_id = '',
                                ...args
                            } = sub;
                            const name = firstLetter((deliveryTypes[delivery_type_id] || delivery_type_id).replace(/_/g, ' '));
                            const suffix = name.indexOf(deliveryType[DELIVERY_TYPE.DIRECT].name) === -1 ? 'into' : '';
                            return <div key={sub.delivery_type_id + sub.tank_id + sub.sub_id} className={styles.tankStep}>
                                <div className='flex flex-col'>
                                    <div data-lev='est-time'>{datetime(est_start_time).format(SHORT_DATETIME_FORMAT)}</div>
                                </div>
                                <div className='flex flex-col items-end' data-lev='job'>
                                    <div className='text-[18px] leading-[20px]'>Discharging {suffix} {name}</div>
                                    <div className='flex text-[14px]'>
                                        <InfoFish data={args} />
                                    </div>
                                    <div className={[styles.arrow, 'arrow-down'].join(' ')}></div>
                                </div>
                                <div className='flex flex-col'>
                                    <div data-lev='est-time'>{datetime(est_finish_time).format(SHORT_DATETIME_FORMAT)}</div>
                                </div>
                            </div>
                        })}
                    </div>
                })
                : <div className='flex flex-col items-center'>
                    <div data-lev='est-time'>{real_start_time ? datetime(real_start_time).format(SHORT_DATETIME_FORMAT) : '...'}</div>
                    <div className='text-[18px]'>{stepNameV2(key)}</div>
                </div>}
        </div>
    </div>;
};

const stepViews: { [id: string]: React.FC<IStepProps> } = {
    [KeyOfStep.HARVEST]: Harvesting,
    [KeyOfStep.DISCHARGE_FACTORY]: Discharging
}

const StepView: React.FC<{ data: IActivityLog, op: IOperation2<IHarvest2>, tanks?: IStorage[] | IHarvest['tanks'], deliveryTypes?: Record<string, string> }> = ({ data, op, tanks, deliveryTypes }) => {
    const { key } = data;
    const { [key]: View = NormalStep } = stepViews;
    return <View
        data={data}
        sub_operations={op.operation.sub_operations}
        deliveryTypes={deliveryTypes}
        vesselTanks={tanks as IHarvest['tanks'] || op.operation.tanks || []}
    />
}

export default StepView